import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import firstlistingimage from '../assets/firstlisting.png'
import '../style/signup.css'; // reuse existing styles or create a new one
import socialmediaimage from '../assets/socialmedia.png'

const socialmedia = () => {
  return (
    <section className='signup'>
      <Container>
        <Row className="align-items-center">
          {/* Form Section */}
          <Col lg={7} className="form-section p-4">
            <h2>
             Social <em className="fw-semibold">Media </em>
            </h2>
            <p>Enter the profile name for each account. We’ll handle the rest</p>

            <Form className="mt-4">
                <Form.Group className="mb-3">
                <Form.Label>Facebbok</Form.Label>
                <Form.Control type="text" />
              </Form.Group>

<Form.Group className="mb-3">
                <Form.Label>Instagram</Form.Label>
                <Form.Control type="text" />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Tiktok</Form.Label>
                <Form.Control type="text" />
              </Form.Group>

                <Form.Group className="mb-3">
                <Form.Label>Youtube</Form.Label>
                <Form.Control type="text" />
              </Form.Group>

              <div className="form-check communicationoptions mb-2">
                <h4>Communication Options</h4>
                <input className="form-check-input mt-1" type="checkbox" id="terms" />
                <label className="form-check-label small" htmlFor="terms">
                  Recieve Helpful Emails from Us
                </label>
              </div>

              

              <Button type="submit" className="w-100 mt-3 btn btn-submit">
                Next Step
              </Button>
            </Form>
          </Col>

          {/* Image Section */}
          <Col lg={5} className="image-section text-center">
            <img
              src={socialmediaimage}
              alt="Farmers Market"
              className="img-fluid rounded shadow"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default socialmedia;
